import fetcher from '../fetcher';
import { useApiWithFlashBase } from './useApiWithFlashBase';

export const useApiWithFlash = () => {
  return useApiWithFlashBase(fetcher);
};
